import { useEffect, useRef, useState, type RefObject } from 'react';

export interface PageView {
  /** khoảng đã cuộn qua đầu danh sách (≥ 0 khi đầu danh sách đã lên khỏi mép trên vùng cuộn) */
  top: number;
  /** chiều cao khung nhìn của vùng cuộn */
  h: number;
}

/** Cuộn ảo theo vùng cuộn duy nhất của trang (`main` của khung app), như board Mint-Job: danh sách không có khung cuộn riêng.
 *  `deps` đổi (số dòng, kiểu xem…) thì đo lại. */
export function usePageScroll(list: RefObject<HTMLElement | null>, deps: readonly unknown[]): PageView {
  const [view, setView] = useState<PageView>({ top: 0, h: 640 });
  const frame = useRef(0);
  useEffect(() => {
    const el = list.current;
    const sc = el?.closest('main');
    if (!el || !sc) return;
    const measure = () => {
      frame.current = 0;
      const next = { top: Math.max(0, Math.round(sc.getBoundingClientRect().top - el.getBoundingClientRect().top)), h: sc.clientHeight || 640 };
      setView((v) => (v.top === next.top && v.h === next.h ? v : next));
    };
    const schedule = () => {
      if (!frame.current) frame.current = requestAnimationFrame(measure);
    };
    measure();
    sc.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    return () => {
      sc.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (frame.current) cancelAnimationFrame(frame.current);
      frame.current = 0;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return view;
}
